<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
          <h3 class="text-themecolor">Limited Partners
            <span class="card-subtitle" v-if="investor.name">{{investor.name}} ({{investor.cp_email}})</span>
            <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/investors/'+id+'/contacts')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">{{trans('investor.investor_list')}}</span></button>
          </h3>
        </div>
        <div class="container-fluid p-0" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12 col-sm-12">
                    <div class="card">
                        <div class="card-body p-4">
                            <div class="row">
                                <user-sidebar menu="contacts" :id="id"></user-sidebar>
                                <div class="col-9 col-sm-9">
                                    <h4 class="card-title" v-text="contact_id?'Edit Contact':'New Contact'"></h4>
                                    <form @submit.prevent="submit" @keydown="investorContactForm.errors.clear($event.target.name)">
                                        <div class="row">
                                            <div class="col-12 col-sm-12">
                                                <div class="row">                                                  
                                                    <div class="col-12 col-sm-6">
                                                        <div class="form-group">
                                                            <label for="">{{trans('investor_contact.first_name')}}</label>
                                                            <input class="form-control"  type="text" value="" v-model="investorContactForm.first_name" name="first_name" :placeholder="trans('investor_contact.first_name')">
                                                            <show-error :form-name="investorContactForm" prop-name="first_name"></show-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                        <div class="form-group">
                                                            <label for="">{{trans('investor_contact.last_name')}}</label>
                                                            <input class="form-control" type="text" value="" v-model="investorContactForm.last_name" name="last_name" :placeholder="trans('investor_contact.last_name')">
                                                            <show-error :form-name="investorContactForm" prop-name="last_name"></show-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                        <div class="form-group">
                                                            <label for="">{{trans('investor_contact.email_work')}}</label>
                                                            <input class="form-control" type="text" value="" v-model="investorContactForm.email_work" name="email_work" :placeholder="trans('investor_contact.email_work')">
                                                            <show-error :form-name="investorContactForm" prop-name="email_work"></show-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-6">
                                                      <div class="form-group">
                                                        <label for="">{{trans('investor_contact.phone_work')}}</label>
                                                        <input class="form-control" type="text" value="" v-model="investorContactForm.phone_work" name="phone_work">
                                                        <show-error :form-name="investorContactForm" prop-name="phone_work"></show-error>
                                                      </div>
                                                    </div>
                                                  <div class="col-12 col-sm-6">
                                                    <div class="form-group">
                                                      <label for="">Job Title</label>
                                                      <input class="form-control" type="text" value="" v-model="investorContactForm.job_title" name="job_title">
                                                      <show-error :form-name="investorContactForm" prop-name="job_title"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-6">
                                                    <div class="form-group">
                                                      <label for="">Label</label>
                                                      <select class="form-control" v-model="investorContactForm.label" name="active">
                                                        <option value="">None</option>
                                                        <option v-for="(label, index) in labels" :key="label.name">
                                                          {{ label.name }}
                                                        </option>
                                                      </select>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-6">
                                                    <div class="form-group">
                                                      <label for="">Preferred Fund Type</label>
                                                      <v-select label="name" track-by="name" v-model="selected_preferred_fund_types" name="preferred_fund_type" id="preferred_fund_type" :options="preferred_fund_types" :placeholder="'Please choose'" @select="onPreferredFundTypeSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onPreferredFundTypeRemove" :selected="selected_preferred_fund_types"></v-select>
                                                      <show-error :form-name="investorContactForm" prop-name="preferred_fund_type"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-6">
                                                    <div class="form-group">
                                                      <label for="">Limited Partner Type</label>
                                                      <v-select label="name" track-by="name" v-model="selected_limited_partner_types" name="limited_partner_type" id="limited_partner_type" :options="limited_partner_types" :placeholder="'Please choose'" @select="onLimitedPartnerTypeSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onLimitedPartnerTypeRemove" :selected="selected_limited_partner_types"></v-select>
                                                      <show-error :form-name="investorContactForm" prop-name="limited_partner_type"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-6">
                                                    <div class="form-group">
                                                      <label for="">Country</label>
                                                      <v-select label="name" track-by="name" v-model="selected_countries" name="country" id="country" :options="countries" :placeholder="'Please choose'" @select="onCountrySelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onCountryRemove" :selected="selected_countries"></v-select>
                                                      <show-error :form-name="investorContactForm" prop-name="country"></show-error>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-sm-6">
                                                    <div class="form-group">
                                                      <label for="">Continent</label>
                                                      <v-select label="name" track-by="name" v-model="selected_continents" name="continent" id="continent" :options="continents" :placeholder="'Please choose'" @select="onContinentSelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onContinentRemove" :selected="selected_continents"></v-select>
                                                      <show-error :form-name="investorContactForm" prop-name="preferred_continent"></show-error>
                                                    </div>
                                                  </div>
                                                </div>
                                        </div>
                                        </div>
                                      <button type="submit" class="btn btn-sm btn-info pull-right" v-text="contact_id?trans('general.save'):trans('general.create')"></button>
                                      <button type="button" style="margin-right:10px;" class="btn btn-sm btn-info pull-right" @click="$router.push('/account/investors/'+id+'/contacts')">{{trans('general.cancel')}}</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import vSelect from 'vue-multiselect'
    import userSidebar from "./investor-sidebar.vue";

    export default {
        components : {userSidebar,vSelect},
        data() {
            return {
                id:this.$route.params.id,
                contact_id:this.$route.params.cid,
                investor: '',
                investorContactForm: new Form({
                    first_name: '',
                    last_name: '',
                    email_work: '',
                    phone_work: '',
                    job_title: '',
                    label: '',
                    preferred_fund_type: [],
                    limited_partner_type: [],
                    country: [],
                    preferred_continent: [],
                    investor_id: 0
                },false),
                investor_contact: '',
                selected_preferred_fund_types: [],
                preferred_fund_type: [],
                preferred_fund_types : [
                  {
                    id: 1,
                    name: "Real Estate"
                  },
                  {
                    id: 2,
                    name: "Venture Capital"
                  },
                  {
                    id: 3,
                    name: "Infrastructure"
                  },
                  {
                    id: 4,
                    name: "Private Equity"
                  },
                  {
                    id: 5,
                    name: "Other"
                  }
                ],
                selected_continents: [],
                continents: [],
                continent: [],
                selected_countries: [],
                countries: [],
                country: [],
                limited_partner_types : [
                  {
                    id: 1,
                    name: "High-net-worth investor"
                  },
                  {
                    id: 2,
                    name: "Family Offices"
                  },
                  {
                    id: 3,
                    name: "Institutional Investor"
                  }
                ],
                labels : [
                  {
                    id: 1,
                    name: "Close Investor"
                  },
                  {
                    id: 2,
                    name: "Known Investor"
                  },
                  {
                    id: 3,
                    name: "Not an Investor"
                  },
                  {
                    id: 4,
                    name: "Do not contact"
                  },
                  {
                    id: 5,
                    name: "Colleague Known"
                  },
                  {
                    id: 6,
                    name: "UNSUBSCRIBED"
                  },
                  {
                    id: 5,
                    name: "Left the firm"
                  },
                  {
                    id: 6,
                    name: "CLOSE BUT LEFT FIRM"
                  }
                ],
                limited_partner_type: [],
                selected_limited_partner_types: []
            };
        },
        mounted(){
           if(this.contact_id=='new'){
             this.contact_id = 0;
           }
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/account/investor-contacts');
            }
            this.prerequisite();


              this.fetchInvestorData();
        },
        methods: {
          fetchInvestorData(){
            axios.get('/api/investor/'+this.id)
                .then(response => response.data)
                .then(response => {
                  this.investor = response.investor;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error);
                  this.$router.push('/investor');
                })
          },
          prerequisite(){
            axios.get('/api/user/profile/questionnaire/pre-requisite')
                .then(response => response.data)
                .then(response => {
                  this.continents       = response.continents;
                  this.countries        = response.countries;
                      if(this.contact_id && this.contact_id!=0) {
                        this.fetchInvestorContactData();
                      }
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          updateContact(){
            this.selected_main_countries.forEach(function (item) {
              this.investorContactForm.main_country_id.push(item.id);
            }.bind(this));

          },
            fetchInvestorContactData(){
                axios.get('/api/investor-contact/'+this.contact_id)
                    .then(response => response.data)
                    .then(response => {
                        this.investor_contact = response;
                        this.investorContactForm.first_name = response.first_name;
                        this.investorContactForm.last_name = response.last_name;
                        this.investorContactForm.email_work = response.email_work;

                        if(Array.isArray(response.phone_work)){
                          this.investorContactForm.phone_work = response.phone_work.join(",");
                        }else{
                          this.investorContactForm.phone_work = response.phone_work;
                        }

                        this.investorContactForm.job_title = response.job_title;
                        this.investorContactForm.label = response.label;
                        // this.investorContactForm.preferred_fund_type = response.preferred_fund_type;
                        // this.investorContactForm.limited_partner_type = response.limited_partner_type;
                        // this.investorContactForm.country = response.country;
                        // this.investorContactForm.preferred_continent = response.preferred_continent;

                        if(response.country){
                          this.selected_countries    = response.country;
                        }else{
                          this.selected_countries    = [];
                        }
                        if(response.preferred_continent){
                          this.selected_continents    = response.preferred_continent;
                        }else{
                          this.selected_continentes    = [];
                        }
                        if(response.preferred_fund_type){
                          this.selected_preferred_fund_types    = response.preferred_fund_type;
                        }else{
                          this.selected_preferred_fund_types    = [];
                        }
                        if(response.limited_partner_type){
                          this.selected_limited_partner_types    = response.limited_partner_type;
                        }else{
                          this.selected_limited_partner_types    = [];
                        }
                      })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.$router.push('/account/investor-contacts');
                    })
            },
          submit(){

            this.selected_limited_partner_types.forEach(function (item) {
              this.investorContactForm.limited_partner_type.push(item.name);
            }.bind(this));
            this.selected_countries.forEach(function (item) {
              this.investorContactForm.country.push(item.name);
            }.bind(this));
            this.selected_continents.forEach(function (item) {
              this.investorContactForm.preferred_continent.push(item.name);
            }.bind(this));
            this.selected_preferred_fund_types.forEach(function (item) {
              this.investorContactForm.preferred_fund_type.push(item.name);
            }.bind(this));

            if(this.contact_id){
              this.investorContactForm.patch('/api/investor-contact/'+this.contact_id)
                  .then(response => {
                    this.investorContactForm.limited_partner_type = [];
                    this.investorContactForm.country = [];
                    this.investorContactForm.preferred_continent = [];
                    this.investorContactForm.preferred_fund_type = [];
                    this.fetchInvestorContactData();
                    toastr.success(response.message);
                  })
                  .catch(error => {
                    helper.showErrorMsg(error);
                  });
            }else{
              this.investorContactForm.investor_id =  this.id;
              this.investorContactForm.post('/api/investor-contact')
                  .then(response => {
                    this.investorContactForm.limited_partner_type = [];
                    this.investorContactForm.country = [];
                    this.investorContactForm.preferred_continent = [];
                    this.investorContactForm.preferred_fund_type = [];
                    toastr.success(response.message);
                    this.$router.push('/account/investors/'+this.id+'/contacts');
                  })
                  .catch(error => {
                    helper.showErrorMsg(error);
                  });
            }

          },
          onCountrySelect(selectedOption){
            this.investorContactForm.errors.clear('country');
            this.country.push(selectedOption.id);
          },
          onCountryRemove(removedOption){
            this.country.splice(this.country.indexOf(removedOption.id), 1);
          },
          onContinentSelect(selectedOption){
            this.investorContactForm.errors.clear('continent');
            this.continent.push(selectedOption.id);
          },
          onContinentRemove(removedOption){
            this.continent.splice(this.continent.indexOf(removedOption.id), 1);
          },
          onLimitedPartnerTypeSelect(selectedOption){
            this.investorContactForm.errors.clear('limited_partner_type');
            this.limited_partner_type.push(selectedOption.id);
          },
          onLimitedPartnerTypeRemove(removedOption){
            this.limited_partner_type.splice(this.limited_partner_type.indexOf(removedOption.id), 1);
          },
          onPreferredFundTypeSelect(selectedOption){
            this.investorContactForm.errors.clear('preferred_fund_type');
            this.preferred_fund_type.push(selectedOption.id);
          },
          onPreferredFundTypeRemove(removedOption){
            this.preferred_fund_type.splice(this.preferred_fund_type.indexOf(removedOption.id), 1);
          },

        }
    }
</script>
